import { OrderExpirationType } from 'enums/modules/order/orderExpirationType';
import { useTranslation } from 'react-i18next';

const useOrderExpirationText = (
  expiration: OrderExpirationType | null
): string | null => {
  const { t } = useTranslation();

  const data = {
    [OrderExpirationType.Day]: t('orderExpirationDay'),
    [OrderExpirationType.Day24h]: t('orderExpirationDay24h'),
    [OrderExpirationType.UntilCanceled]: t('orderExpirationUntilCanceled'),
  };

  return expiration ? data[expiration] : null;
};

export default useOrderExpirationText;
